import { SupportContact } from '../SupportContact.js'
import { SettingsSectionCard } from './SettingsSectionCard.js'

export function SettingsContactSection() {
  return (
    <SettingsSectionCard
      title="運営への問い合わせ"
      description="プラン変更・トラブル・その他のご相談はこちらからご連絡ください。"
    >
      <SupportContact
        subject="お問い合わせ"
        label="運営に問い合わせる"
        className="inline-flex items-center gap-2 px-4 py-2 border border-border rounded-md text-sm font-medium hover:bg-accent transition-colors"
      />
    </SettingsSectionCard>
  )
}
